// import React from "react";
// import MUIBreadcrumbs from "@mui/material/Breadcrumbs";
// import Link from "../Link";
// import Typography from "../Typography";
// import theme from "theme";
// import TooltipText from "components/TooltipText";
// import InnoIcons from "@InnoIcons/";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { projectType } from "utils/lookUpTable";
// import SC from "./style";

// const Breadcrumbs = (props) => {
//   const { items = [], typographyText, separator, currentPath, onClick } = props;
//   const [searchParams] = useSearchParams();
//   const type = searchParams.get("type");
//   const navigate = useNavigate();

//   console.log(items, "dfdf");

//   const handleClick = (e, href) => {
//     console.log(href, "tyty");

//     e.preventDefault(); // Always prevent the default

//     if (onClick) {
//       if (!href) {
//         navigate("/project-home");
//       }
//       onClick(href);
//     } else {
//       navigate(href); // Always use react-router navigation
//     }
//   };

//   const handleBackClick = () => {
//     if (type == 0) navigate("/");
//     if (type == 1)
//       navigate(`/project-home/generalinformation?type=${projectType.property}`);
//   };

//   return (
//     <SC.Container role="presentation">
//       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//         {type && (
//           <InnoIcons.ArrowBackIcon
//             sx={{ cursor: "pointer", fontSize: "20px" }}
//             onClick={handleBackClick}
//           />
//         )}
//         <MUIBreadcrumbs separator={separator} aria-label="breadcrumb">
//           {items.map((item, index) => {
//             const isLastItem = index === items.length - 1;
//             return (
//               <SC.LinkTag
//                 key={index}
//                 underline="none"
//                 color={isLastItem ? `${theme.colors.themeColor}` : "#333333"}
//                 // href={item.href}
//                 aria-current={item.href === currentPath ? "page" : undefined}
//                 onClick={(e) => handleClick(e, item.href)}
//                 sx={{
//                   fontWeight: isLastItem ? "bold" : "bold",
//                 }}
//               >
//                 <TooltipText title={item.label} maxLength={30} />
//               </SC.LinkTag>
//             );
//           })}
//           {typographyText && (
//             <Typography color="text.primary">{typographyText}</Typography>
//           )}
//         </MUIBreadcrumbs>
//       </div>
//     </SC.Container>
//   );
// };

// export default Breadcrumbs;

import React, { useEffect, useState } from "react";
import MUIBreadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "../Typography";
import theme from "theme";
import TooltipText from "components/TooltipText";
import InnoIcons from "@InnoIcons/";
import { useNavigate, useSearchParams } from "react-router-dom";
import { projectType } from "utils/lookUpTable";
import SC from "./style";
import { apiPost } from "api/callApi";
import { isValidFolderId } from "utils/helper";

const Breadcrumbs = (props) => {
  const { items = [], typographyText, separator, currentPath, onClick } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const folderId = searchParams.get("folderId");
  const projectId = searchParams.get("projectId");
  const fileId = searchParams.get("fileId");
  const navigate = useNavigate();
  const [data, setData] = useState();

  const getBredcrumbsData = async () => {
    try {
      if (!isValidFolderId(folderId)) {
        setData("");
        return;
      }
      const result = await apiPost(`/v1/file/path/breadcrum/${folderId}`);
      setData(result.path);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getBredcrumbsData();
  }, [folderId]);

  const handleClick = (e, href) => {
    if (onClick) {
      e.preventDefault();
      onClick(href);
    }
  };

  const handleBackClick = () => {
    if (type == 0) navigate("/");
    if (type == 1)
      navigate(`/project-home/generalinformation?type=${projectType.property}`);
  };

  const handleClickData = () => {
    if (fileId) {
      navigate(
        `/document?projectId=${projectId}&folderId=${folderId}&type=${type}`
      );
    }
  };

  return (
    <SC.BodyHeader>
      <SC.Container role="presentation">
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {type && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onClick={handleBackClick}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              {type == 0 ? (
                <InnoIcons.DashboardIcon
                  sx={{
                    fontSize: "20px",
                    color: "white",
                  }}
                />
              ) : (
                <InnoIcons.ArrowBackIcon
                  sx={{
                    fontSize: "20px",
                    color: "white",
                  }}
                />
              )}
            </div>
          )}
          <MUIBreadcrumbs separator={separator} aria-label="breadcrumb">
            {items.map((item, index) => {
              const isLastItem = index === items.length - 1;
              return (
                <SC.LinkTag
                  key={index}
                  underline="none"
                  color={isLastItem ? `${theme.colors.themeColor}` : "#333333"}
                  // color={
                  //   isLastItem
                  //     ? `${theme.colors.themeColor}`
                  //     : item.href === currentPath
                  //     ? `${theme.colors.themeColor}`
                  //     : "black"
                  // }
                  href={item.href}
                  aria-current={item.href === currentPath ? "page" : undefined}
                  onClick={(e) => handleClick(e, item.href)}
                  sx={{
                    fontWeight: isLastItem ? "bold" : "bold",
                  }}
                >
                  <TooltipText title={item.label} maxLength={30} />
                </SC.LinkTag>
              );
            })}
            {data && <SC.LinkTag onClick={handleClickData}>{data}</SC.LinkTag>}
            {typographyText && (
              <Typography color="text.primary">{typographyText}</Typography>
            )}
          </MUIBreadcrumbs>
        </div>
      </SC.Container>
    </SC.BodyHeader>
  );
};

export default Breadcrumbs;
